const state = () => ({
  resumeReviewAgreement: false,
  list: [],
  isResumeListLoading: false,

  isMyResumeUploading: false,
  myResume: null,

  hasUsedCVCheck: false,
  isCVCheckLoading: false,
  topCVStatus: null,
  iframeUrl: null,
  reviewRate: 0,
  reviewRateLoading: false,
  isTopCVUploadLoading: false,
  isCheckingTopCVStatus: false,
  freeReviewSettings: null,
  resumeProvider: null,
  freeResumeReview: null,
});

// mutations
const mutations = {
  setResumeReviewAgreement(currentState, newValue) {
    currentState.resumeReviewAgreement = newValue;
  },
  setList(currentState, newValue) {
    currentState.list = newValue;
  },
  setResumeListLoading(currentState, newValue) {
    currentState.isResumeListLoading = newValue;
  },
  setIsMyResumeUploading(currentState, newValue) {
    currentState.isMyResumeUploading = newValue;
  },
  setMyResume(currentState, newValue) {
    currentState.myResume = newValue;
  },
  setHasUsedCVCheck(currentState, newValue) {
    currentState.hasUsedCVCheck = newValue;
  },
  setIsCVCheckLoading(currentState, newValue) {
    currentState.isCVCheckLoading = newValue;
  },
  setTopCVStatus(currentState, newValue) {
    currentState.topCVStatus = newValue;
  },

  setIframeUrl(currentState, newValue) {
    currentState.iframeUrl = newValue;
  },
  setReviewRate(currentState, newValue) {
    currentState.reviewRate = newValue;
  },
  setReviewRateLoading(currentState, newValue) {
    currentState.reviewRateLoading = newValue;
  },
  setIsTopCVUploadLoading(currentState, newValue) {
    currentState.isTopCVUploadLoading = newValue;
  },
  setIsCheckingTopCVStatus(currentState, newValue) {
    currentState.isCheckingTopCVStatus = newValue;
  },
  setFreeReviewSettings(currentState, newValue) {
    currentState.freeReviewSettings = newValue;
  },
  setTopCVProvider(currentState, newValue) {
    currentState.resumeProvider = newValue;
  },
  setFreeResumeReview(currentState, newValue) {
    currentState.freeResumeReview = newValue;
  },
};

// actions
const actions = {
  fetchResumeList({ commit }) {
    commit('setResumeListLoading', true);
    commit('setList', []);
    this.$api
      .get(this.getters.getApiLink('resume.list'))
      .then(({ data }) => {
        if (Array.isArray(data) && data.length) {
          commit('setList', data);

          // put last resume as a current
          commit('setMyResume', data[data.length - 1]);
        }
      })
      .finally(() => {
        commit('setResumeListLoading', false);
      });
  },
  uploadMyResume({ commit }, payload) {
    commit('setIsMyResumeUploading', true);
    return this.$api
      .file(this.getters.getApiLink('user.profileDocuments'), payload)
      .then(({ data }) => {
        commit('setMyResume', data);
        return data;
      })
      .catch(({ response }) => {
        throw response.data;
      })
      .finally(() => commit('setIsMyResumeUploading', false));
  },

  checkTopCVStatus({ commit }) {
    commit('setTopCVStatus', null);
    commit('setIframeUrl', null);
    commit('setIsTopCVUploadLoading', true);
    commit('setIsCheckingTopCVStatus', true);
    commit('setTopCVProvider', null);
    return this.$api
      .get(this.getters.getApiLink('resume.topCvStatus'))
      .then(({ data }) => {
        if (data) {
          // data = {"has_used_cv_check":true,"rating":null,"status":"CLOSED","url":"/"}
          commit('setTopCVStatus', data.status);
          if (data.status === 'CLOSED' && data.url) {
            commit('setIframeUrl', data.url);
            if (data.rating) {
              commit('setReviewRate', data.rating);
            }
            if (data.provider) {
              commit('setTopCVProvider', data.provider);
            }
          }
        }
        if (data.has_used_cv_check) {
          commit('setHasUsedCVCheck', data.has_used_cv_check);
        }
        return data;
      })
      .catch(() => {
        commit('setTopCVStatus', null);
        throw new Error('something goes wrong');
      })
      .finally(() => {
        commit('setIsTopCVUploadLoading', false);
        commit('setIsCheckingTopCVStatus', false);
      });
  },
  getTopCVPackages({ rootGetters }, payload) {
    let link = `/api/v2/user/profile/top-cv/purchase-package`;
    if (payload) {
      link += `/${payload}`;
    }
    link += `?country=${rootGetters['country/currentCountry'].countryCode}`;
    return this.$api
      .get(link)
      .then(({ data }) => data)
      .catch((e) => {
        throw new Error(e);
      });
  },

  setReviewRate({ state: currentState, commit }, payload) {
    if (currentState.reviewRateLoading) {
      return false;
    }
    commit('setReviewRateLoading', true);
    return this.$api
      .get(this.getters.getApiLink('resume.topCvRate') + `/${payload}`)
      .then(({ data }) => {
        if (data) {
          commit('setReviewRate', payload);
        }
        return true;
      })
      .catch(() => {
        throw new Error('Something goes wrong');
      })
      .finally(() => {
        commit('setReviewRateLoading', false);
      });
  },
  reviewOpenedTracking() {
    return this.$api.get(this.getters.getApiLink('resume.topCvTrackView')).catch(() => {
      throw new Error('Something goes wrong');
    });
  },
  topCVUpload({ commit }, payload) {
    commit('setIsTopCVUploadLoading', true);
    return this.$api
      .file(this.getters.getApiLink('user.profileDocuments'), payload)
      .then(({ data }) => data)
      .catch(({ response }) => {
        throw response.data;
      })
      .finally(() => commit('setIsTopCVUploadLoading', false));
  },
  getFreeResumeSettings({ commit, rootGetters }) {
    commit('setFreeReviewSettings', []);
    this.$api
      .get(this.getters.getApiLink('resume.freeReviewSettings') + '/' + rootGetters.locale)
      .then(({ data }) => {
        //       data = [
        //     {
        //         "name": "English",
        //         "provider": "topcv",
        //         "code": "en"
        //     },
        //     {
        //         "name": "German",
        //         "provider": "topcv",
        //         "code": "de"
        //     },
        //     {
        //         "name": "French",
        //         "provider": "sovren",
        //         "code": "fr"
        //     },
        //     {
        //         "name": "Italian",
        //         "provider": "sovren",
        //         "code": "it"
        //     },
        //     {
        //         "name": "Spanish",
        //         "provider": "sovren",
        //         "code": "es"
        //     },
        //     {
        //         "name": "Portugese",
        //         "provider": "sovren",
        //         "code": "pt"
        //     }
        // ]
        if (Array.isArray(data) && data.length) {
          commit('setFreeReviewSettings', data);
        }
      });
  },
  getFreeResumeReview({ commit }, payload) {
    commit('setFreeResumeReview', []);
    this.$api.get(payload).then(({ data }) => {
      commit('setFreeResumeReview', data);
    });
  },
};
// actions end

const getters = {
  resumeReviewAgreement: (s) => s.resumeReviewAgreement,
  isResumeListLoading: (s) => s.isResumeListLoading,
  isMyResumeUploading: (s) => s.isMyResumeUploading,
  myResume: (s) => s.myResume,
  hasUsedCVCheck: (s) => s.hasUsedCVCheck,
  isCVCheckLoading: (s) => s.isCVCheckLoading,
  topCVStatus: (s) => s.topCVStatus,
  iframeUrl: (s) => s.iframeUrl,
  reviewRate: (s) => s.reviewRate,
  isTopCVUploadLoading: (s) => s.isTopCVUploadLoading,
  isCheckingTopCVStatus: (s) => s.isCheckingTopCVStatus,
  freeReviewSettings: (s) => s.freeReviewSettings,
  resumeProvider: (s) => s.resumeProvider,
  freeResumeReview: (s) => s.freeResumeReview,
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
};
